module.exports = __webpack_public_path__ + "img/11.bece5f56.png";